import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Spin } from "antd";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();

  console.log('PrivateRoute check:', { isAuthenticated, isLoading, path: location.pathname });

  // Zeige Ladeindikator während der Initialisierung (max 5 Sekunden)
  if (isLoading) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f2f5"
      }}>
        <Spin size="large" />
        <div style={{ marginTop: 16, color: "#666" }}>Authentifizierung wird geprüft...</div>
      </div>
    );
  }

  // Leite zu Login weiter, wenn nicht authentifiziert
  if (!isAuthenticated) {
    console.log('PrivateRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Zeige geschützten Inhalt
  return children;
};

export default PrivateRoute;
